import { FiRrInfo } from '@app/assets';
import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

export const ShortURLWarningBanner: React.FC<{ children?: ReactNode; withWrapper?: boolean }> = ({
  children,
  withWrapper = true,
}) => {
  const { t } = useTranslation();

  if (!withWrapper) {
    return <>{children}</>;
  }

  return (
    <div className="flex gap-3 items-start rounded-lg bg-gray-100 border border-gray-300 p-4">
      <FiRrInfo className="shrink-0 text-error mt-1" />
      <div className="flex flex-col gap-3">
        <p className="flex gap-1 flex-wrap font-bold text-m text-gray-800">
          {t('qr.settings.global.warningBanner.title')}
        </p>
        <p className="flex gap-1 flex-wrap text-gray-800">
          <Trans i18nKey={'qr.settings.global.warningBanner.description'}>
            <b />
          </Trans>
        </p>
        {children}
      </div>
    </div>
  );
};
